import type { Theme, SxProps } from '@mui/material/styles';

import { FileThumbnail } from '@/components/file-thumbnail';
import { Box, ListItemText, Paper } from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  files?: {
    title?: string;
    subtitle?: string;
  }[];
  sx?: SxProps<Theme>;
};

export function DetailsFiles({ files, sx }: Props) {
  const renderText = (_file: { title?: string; subtitle?: string }) => (
    <ListItemText
      onClick={() => {}}
      sx={{ p: 1 }}
      primary={_file.title}
      secondary={<>{_file.subtitle}</>}
      slotProps={{
        primary: { noWrap: true },
        secondary: {
          sx: {
            mt: 0.5,
            alignItems: 'center',
            typography: 'caption',
            color: 'text.disabled',
            display: 'inline-flex',
          },
        },
      }}
    />
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', pt: 3, pl: 1, pr: 1, pb: 4 }}>
      {files?.map((file) => (
        <Paper
          sx={[
            (theme) => ({
              borderRadius: 0,
              display: 'flex',
              cursor: 'pointer',
              position: 'relative',
              // bgcolor: 'transparent',
              p: { xs: 2.5, sm: 2 },
              alignItems: { xs: 'unset', sm: 'center' },
              flexDirection: { xs: 'column', sm: 'row' },
              '&:hover': { bgcolor: theme.palette.grey['100'] },
            }),
            ...(Array.isArray(sx) ? sx : [sx]),
          ]}>
          <FileThumbnail file="text" />

          {renderText(file)}
        </Paper>
      ))}
    </Box>
  );
}
